import { useEffect } from 'react'
import { $settings } from '@velasca/utils/globals'
import { KlarnaContainer } from './KlarnaPlacement.styles'
import type { KlarnaPlacementProps } from './KlarnaPlacement.types'

export const KlarnaPlacement = ({
  amount,
  className = '',
}: KlarnaPlacementProps): JSX.Element => {
  useEffect(() => {
    window.Klarna?.OnsiteMessaging?.refresh?.()
  }, [amount])

  if ($settings.store_nation === 'eu') {
    return (
      <KlarnaContainer className={className}>
        <klarna-placement
          data-key="top-strip-promotion-auto-size"
          data-locale="en-AT"
        />
      </KlarnaContainer>
    )
  }

  return (
    <KlarnaContainer className={className}>
      <klarna-placement
        data-key="credit-promotion-auto-size"
        data-locale={$settings.locale}
        data-purchase-amount={amount}
      />
    </KlarnaContainer>
  )
}
